module.exports = __webpack_public_path__ + "img/5da71de5a8d2dad5cfc568af829390b0.png";